import React, { Component } from 'react';
import classnames from 'classnames';
import { Col } from 'react-bootstrap';
import SearchSidebarView from './SearchSidebarView';
import FilterDropdownSidebarView from './FilterDropdownSidebarView';
import FilterSidebarView from './FilterSidebarView';
import GroupModalView from './GroupModalView';
import SelectedGroupFilterView from './SelectedGroupFilterView';

class CommunitySidebarView extends Component {

    handleChange = (value) => {
        this.props.handleChange(value);
    }

    getKeysByType(type) {
        switch (type) {
        case 'group':
            return [{
                displayName: 'Job Title',
                key: 'title'
            },
            {
                displayName: 'Organization',
                key: 'company'
            },
            {
                displayName: 'Country',
                key: 'country'
            }
            ];
        case 'sort':
            return [
                {
                    displayName: 'Recently Joined',
                    key: 'join'
                },
                {
                    displayName: 'Name (A-Z)',
                    key: 'attendeeName'
                },
                {
                    displayName: 'Company (A-Z)',
                    key: 'company'
                },
                {
                    displayName: 'Most Viewed',
                    key: 'views'
                }
            ];

        case 'filter':
            return [
                {
                    displayName: 'All Attendees',
                    key: ''
                },
                {
                    displayName: 'Suggested Connections',
                    key: 'suggested'
                },
                {
                    displayName: 'Starred',
                    key: 'leads'
                },
                {
                    displayName: 'Who Viewed My Profile',
                    key: 'view'
                }
            ];
        }
    }

    getGroupDisplayName = (groupKey) => {
        if (!groupKey) {
            return;
        }

        const groups = this.getKeysByType('group');
        const groupIndex = groups.findIndex(group => group.key === groupKey);
        return groups[groupIndex].displayName;
    };

    toggleMenu = () => {
        this.props.toggleMobileMenuChanged();
    }

    handleMobileSearchSubmit = (e) => {
        e.preventDefault();
        this.refs.mobileSearch.blurInput();
        this.toggleMenu();
    }

    render() {
        var cx = classnames;
        var openMobileMenu = cx('hidden-sm hidden-md hidden-lg padding-bottom-medium padding-top-small mobile-navigation', {'move': this.props.toggleMobileMenu});
        return (
            <div>
                <div className="sticky-sidebar sidebar container hidden-xs">
                    <SearchSidebarView name="SEARCH" placeHolder="People, organizations and more..." handleChange={this.handleChange} defaultValue={this.props.search.q}/>

                    <SelectedGroupFilterView handleChange={this.handleChange.bind(this)}
                        search={this.props.search}
                        facets={this.props.facets}
                        attributeSelected={this.props.attributeSelected}
                        opposite={true}
                        handleClearAll={this.props.handleClearAll}/>

                    <FilterSidebarView name="GROUP SEARCH"
                        keys={this.getKeysByType('group')}
                        handleChange={this.handleChange.bind(this)}
                        toggleMenuChanged={this.props.toggleMenuChanged}
                        type="group"
                        attributeSelected={this.props.attributeSelected}
                        facets={this.props.facets}/>

                    <FilterSidebarView name="SORT BY"
                        keys={this.getKeysByType('sort')}
                        type='sort'
                        handleChange={this.handleChange.bind(this)}
                        value={this.props.search.sort}
                        facets={this.props.facets}/>

                    <FilterSidebarView name="FILTER BY"
                        keys={this.getKeysByType('filter')}
                        type='filter'
                        handleChange={this.handleChange.bind(this)}
                        value={this.props.search.filter}
                        facets={this.props.facets}/>

                    <GroupModalView handleChange={this.handleChange.bind(this)} groupModalOpen={this.props.groupModalOpen}
                        search={this.props.search}
                        facets={this.props.facets}
                        attributeSelected={this.props.attributeSelected}
                        toggleMenuChanged={this.props.toggleMenuChanged}
                        groupDisplayName={this.getGroupDisplayName(this.props.search.group)}/>
                    <div data-iframe-height/>
                    <div data-iframe-height/>

                </div>
                <Col xs={12} className={openMobileMenu}>
                    <form onSubmit={this.handleMobileSearchSubmit}>
                        <SearchSidebarView ref="mobileSearch"
                            name="SEARCH"
                            placeHolder="People, organizations and more..."
                            handleChange={this.handleChange.bind(this)}
                            defaultValue={this.props.search.q}/>

                        <FilterDropdownSidebarView name="SORT BY" keys={this.getKeysByType('sort')} type='sort'
                            handleChange={this.handleChange.bind(this)} value={this.props.search.sort}/>

                        <FilterDropdownSidebarView name="FILTER BY" keys={this.getKeysByType('filter')} type='filter'
                            handleChange={this.handleChange.bind(this)} value={this.props.search.filter}/>
                    </form>
                    <div className="open-menu-container row">
                        <div className="open-menu-container-inner">
                            <div className="open-menu-btn make-relative" onClick={this.toggleMenu}>
                                <i className="icon icon-search search-box-icon open-menu-icon color-1"/>
                            </div>
                        </div>
                    </div>
                </Col>
            </div>
        );
    }
}

export default CommunitySidebarView;
